"use client";

import { graphql, useQuery } from "@opensea/graphql";
import { EmptyState, TextBody } from "@opensea/ui-kit";
import { useTranslations } from "next-intl";
import { useState } from "react";
import { useMarketQueryParam } from "../../hooks/query-param/use-market-query-param";
import { withSuspense } from "../suspense/WithSuspense";
import { CheckboxFilterContent, CheckboxFilterContentItemSide } from "./CheckboxFilterContent";
import { FilterPanel } from "./FilterPanel";
import { MarketplaceCheckboxFilterContent } from "./MarketplaceCheckboxFilterContent";
import { MarketplacePanelSkeleton } from "./MarketplacePanelSkeleton";
const query = graphql(`
  query CollectionMarketplacePanelQuery($slugs: [String!]!) {
    collectionsBySlugs(slugs: $slugs) {
      __typename
      ... on Collection {
        id
        markets {
          listedItemCount
          market {
            identifier
            name
          }
        }
      }
    }
  }
`);
const CONTEXT = {
  ttl: Number.POSITIVE_INFINITY
};
export const CollectionMarketplacePanel = withSuspense(function CollectionMarketplacePanel({
  collectionSlugs,
  showListedItemCount = false
}) {
  const [open, setOpen] = useState(false);
  const {
    markets: selectedMarkets,
    onSelectMarket
  } = useMarketQueryParam();
  const [{
    data
  }] = useQuery({
    query,
    variables: {
      slugs: collectionSlugs
    },
    pause: !(collectionSlugs.length && open),
    context: CONTEXT
  });
  const t = useTranslations("CollectionMarketplacePanel");
  const markets = data?.collectionsBySlugs.flatMap(v => v.__typename === "Collection" ? v.markets : []);
  const combinedListedItemCounts = markets?.reduce((acc, {
    market,
    listedItemCount
  }) => {
    const {
      identifier
    } = market;
    acc[identifier] = (acc[identifier] || 0) + listedItemCount;
    return acc;
  }, {});
  const uniqueMarkets = markets?.reduce((acc, {
    market
  }) => {
    if (!acc.some(m => m.identifier === market.identifier)) {
      acc.push(market);
    }
    return acc;
  }, []);
  return <FilterPanel content={<CheckboxFilterContent>
            {uniqueMarkets?.map(({
      identifier,
      name
    }) => {
      return <MarketplaceCheckboxFilterContent checked={selectedMarkets.includes(identifier)} key={identifier} market={identifier} name={name} onClick={() => onSelectMarket(identifier)}>
                  {showListedItemCount ? <CheckboxFilterContentItemSide asChild>
                      <TextBody className="text-text-secondary" size="sm">
                        {combinedListedItemCounts?.[identifier]}
                      </TextBody>
                    </CheckboxFilterContentItemSide> : null}
                </MarketplaceCheckboxFilterContent>;
    })}
          </CheckboxFilterContent>} onOpenChange={setOpen} open={open}>
        {t("marketplaces")}
      </FilterPanel>;
}, {
  fallback: <MarketplacePanelSkeleton />,
  errorFallback: <EmptyState variant="no-data" />
});